import React, { useEffect, useRef } from 'react'
import { cn } from '../../lib/helpers'

import styles from './infraredReportHero.module.css'
import headerStyles from '../header.module.css'

const InfraredReportHero = ({ video, videoPoster, children, addClass, noTransparent }) => {
  const observerTargetRef = useRef(null)

  useEffect(() => {
    // let isResizing = false
    // let targetWidthPrev = 0
    // let resizeTimeout

    // const adjustLetterSpacing = () => {
    //   if (isResizing) return
    //
    //   const heroHeading = document.querySelector(`.${styles.heroHeading}`)
    //   if (!heroHeading) return
    //
    //   const imgRef = heroHeading.querySelector('img')
    //   if (!imgRef || imgRef.offsetWidth === 0) return
    //
    //   const textRef = heroHeading.querySelector('div span:last-child')
    //   if (!textRef) return
    //
    //   const targetWidth = imgRef.offsetWidth
    //   if (targetWidth === targetWidthPrev) return
    //
    //   targetWidthPrev = targetWidth
    //
    //   const textWidth = textRef.scrollWidth
    //   const textContent = textRef.textContent || ''
    //   if (textContent.length <= 1) return
    //
    //   const lettersCount = textContent.length - 1
    //   const spacing = Math.max((targetWidth - textWidth) / lettersCount, 0)
    //
    //   textRef.style.setProperty('--letter-spacing', `${spacing}px`)
    //   textRef.style.setProperty('--margin-right', `${-spacing}px`)
    // }

    // const handleResize = () => {
    //   isResizing = true
    //   clearTimeout(resizeTimeout)
    //   resizeTimeout = setTimeout(() => {
    //     adjustLetterSpacing()
    //     isResizing = false
    //   }, 150)
    // }

    if (noTransparent) return

    const header = document.querySelector('header')
    const handleIntersection = (entries) => {
      if (!header) return

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          header.classList.add(headerStyles.transparent)
        } else {
          header.classList.remove(headerStyles.transparent)
        }
      })
    }

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1
    })

    // const imgRef = document.querySelector(`.${styles.heroHeading} img`)
    // if (imgRef) {
    //   if (imgRef.complete) {
    //     adjustLetterSpacing()
    //   } else {
    //     imgRef.addEventListener('load', adjustLetterSpacing)
    //   }
    // }

    if (observerTargetRef.current) {
      observer.observe(observerTargetRef.current)
    }

    // window.addEventListener('resize', handleResize)
    // adjustLetterSpacing()

    return () => {
      // window.removeEventListener('resize', handleResize)
      if (observerTargetRef.current) {
        observer.unobserve(observerTargetRef.current)
      }
      // if (imgRef) {
      //   imgRef.removeEventListener('load', adjustLetterSpacing)
      // }
    }
  }, [])

  return (
    <>
      <div
        ref={observerTargetRef} style={{
          height: '1px',
          padding: 0,
          position: 'absolute',
          top: 0,
          background: 'transparent'
        }}
      />
      <div className={cn(styles.heroContainer, addClass)}>
        <div className={styles.videoWrapper}>
          {video?.asset.url && (
            <>
              <video
                autoPlay
                muted
                loop
                playsInline
                className={styles.videoBackground}
                poster={videoPoster.asset.url}
                aria-hidden='true'
              >
                <source src={video.asset.url} type='video/mp4' />
              </video>
            </>)}
        </div>
        <div className={styles.heroWrapper}>
          <div className={styles.heroHeading}>
            {children[0]}
          </div>
          {children[1]}
        </div>
      </div>
    </>
  )
}

export default InfraredReportHero
